import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Files {

  /**
   * Loads all the settings for the file storage.
   * @param {int} project_id The project id.
   */
  static async load(project_id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/files/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          project: project_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Updates the storage quota of the file storage per user.
   * @param {int} project_id The project id.
   * @param {int} storage_quota The storage quota in MB.
   */
  static async updateStorageQuota(project_id, storage_quota){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/files/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          project: project_id,
          function: "update_storage_quota",
          storage_quota: storage_quota
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
